import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  grid-row: 3 / 4;\n  grid-column: 1;\n\n  &::after {\n    position: absolute;\n    left: calc(\n      var(--indicator-offset) +\n        (var(", ") / 2)\n    );\n\n    display: block;\n    width: calc(\n      var(--indicator-size) -\n        var(", ")\n    );\n    height: var(--line-size);\n    margin-top: var(", ");\n\n    background-color: var(", ");\n    opacity: 1;\n\n    transition: width ", "\n        var(", "),\n      left ", " var(", ");\n\n    content: '';\n\n    @media (prefers-reduced-motion) {\n      transition: none;\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  grid-row: 1 / 4;\n  grid-column: 1;\n\n  &::after {\n    position: absolute;\n    left: var(--indicator-offset);\n\n    display: block;\n    width: var(--indicator-size);\n    height: 100%;\n\n    background-color: var(\n      ", "\n    );\n    opacity: 1;\n\n    transition-timing-function: var(", ");\n    transition-duration: ", ";\n\n    transition-property: width, left;\n\n    content: '';\n\n    @media (prefers-reduced-motion) {\n      transition: none;\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  --indicator-size: 0px;\n  --indicator-offset: 0px;\n  position: relative;\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  grid-row: 1 / 4;\n\n  grid-column: 1;\n  justify-content: stretch;\n  margin: 0;\n  padding: 0;\n\n  list-style: none;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  /* stylelint-disable media-feature-name-no-unknown */\n  @media (max-width: ", "px) {\n    flex-grow: 1;\n  }\n\n  & > * {\n    position: relative;\n\n    display: inline-block;\n    height: var(--size);\n    margin: 0px;\n    padding: 0px var(", ");\n\n    color: var(", ");\n    line-height: var(--size);\n    white-space: nowrap;\n    text-decoration: none;\n\n    background: transparent;\n    border: none;\n    border-radius: 0;\n  }\n\n  & > *::-moz-focus-inner {\n    padding: 0;\n\n    border: 0;\n  }\n\n  & > *:hover {\n    color: var(", ");\n  }\n\n  & > *[aria-selected='true'],\n  & > *[aria-current='true'] {\n    color: var(", ");\n  }\n\n  & > *[aria-disabled] {\n    color: var(", ");\n\n    cursor: not-allowed;\n  }\n\n  & > *:focus {\n    outline-width: 1px;\n    outline-style: solid;\n    outline-offset: -1px;\n  }\n\n  & > *:focus:not(:focus-visible) {\n    outline-width: unset;\n    outline-style: unset;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n\n  color: currentColor;\n\n  transition: color 0.1s var(", ");\n\n  pointer-events: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: var(--size);\n  max-height: var(--size);\n  margin: 0;\n  padding: 0;\n\n  color: var(", ");\n\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n\n  transform: ", ";\n  cursor: pointer;\n\n  appearance: none;\n\n  &:hover {\n    color: var(", ");\n  }\n\n  [dir='rtl'] & {\n    transform: ", ";\n  }\n\n  &:disabled {\n    color: var(", ");\n\n    cursor: not-allowed;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: grid;\n\n  grid-template-rows: var(--gutter-size) var(--line-height) var(--gutter-size);\n  overflow-x: auto;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  --size: ", ";\n  --line-height: var(\n    ", "\n  );\n  --line-size: 2px;\n  --gutter-size: calc((var(--size) - var(--line-height)) / 2);\n\n  ", "\n\n  ", "\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { injectHideScrollBar } from '../../utils/injectHideScrollBar';
import { injectTypography } from '../../utils/injectTypography';
import { injectSpacing } from '../../api/spacing/injectSpacing';
var selectAnimationDuration = '130ms';
var smallSize = '46px';
var largeSize = '58px';
export var StyledContainer = styled.div(_templateObject(), function (props) {
  return props.size === 'small' ? smallSize : largeSize;
}, function (props) {
  return props.size === 'small' ? props.theme.responsive.typography.copy2.lineHeight : props.theme.responsive.typography.copy1.lineHeight;
}, function (props) {
  return injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1');
}, injectSpacing('margin'));
export var StyledScrollContainer = styled.div(_templateObject2(), injectHideScrollBar());
export var StyledScrollControl = styled.button(_templateObject3(), function (props) {
  return props.theme.colors.interaction.secondary.default;
}, function (props) {
  return props.position === 'start' ? 'rotate(180deg)' : 'none';
}, function (props) {
  return props.theme.colors.interaction.secondary.hover;
}, function (props) {
  return props.position === 'end' ? 'rotate(180deg)' : 'none';
}, function (props) {
  return props.theme.colors.interaction.secondary.disabled;
});
export var StyledScrollIcon = styled.svg(_templateObject4(), function (props) {
  return props.theme.easing;
});
export var StyledItem = styled.li(_templateObject5(), function (props) {
  return props.theme.breakpoints.m;
}, function (props) {
  return props.theme.responsive.spacing.s;
}, function (props) {
  return props.theme.colors.interaction.secondary.default;
}, function (props) {
  return props.theme.colors.interaction.secondary.hover;
}, function (props) {
  return props.theme.colors.interaction.secondary.active;
}, function (props) {
  return props.theme.colors.interaction.secondary.disabled;
});
export var StyledList = styled.ul(_templateObject6());
export var StyledBlockIndicator = styled.div(_templateObject7(), function (props) {
  return props.theme.colors.ui.highlight.tertiary;
}, function (props) {
  return props.theme.easing;
}, selectAnimationDuration);
export var StyledLineIndicator = styled.div(_templateObject8(), function (props) {
  return props.theme.responsive.spacing.l;
}, function (props) {
  return props.theme.responsive.spacing.l;
}, function (props) {
  return props.theme.responsive.spacing.xxs;
}, function (props) {
  return props.theme.colors.ui.primary;
}, selectAnimationDuration, function (props) {
  return props.theme.easing;
}, selectAnimationDuration, function (props) {
  return props.theme.easing;
});